import Head from "next/head";
//#region [Component]
export default function TrailereSeo() {
	const title = "Trailere - Filmweb";
	const desc = "Se de nyeste trailerne for kommende filmer og TV-serier!"

	return <Head>
		<meta key="ogTitle" property="og:title" content={title} />

		<meta key="ogDescrtiption" property="og:description" content={desc} />
		<meta key="metaDescription" name="description" content={desc} />
		<meta key="ogUrl" property="og:url" content={`https://www.filmweb.no/trailere`} />
		<title key="title">{title}</title>
	</Head>;
}
//#endregion
